import React from 'react'
import { Formik } from 'formik'
import { Trans } from 'react-i18next'

import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import InputTextarea from '../../views/widgets/InputTextarea'

const PortalGalleryImageForm = ({
  initialValues,
  onValidate,
  onSubmit,
  onRequestClose,
  language = 'th',
}) => (
  <Formik
    enableReinitialize={true}
    initialValues={initialValues}
    onValidate={onValidate}
    onSubmit={onSubmit}
  >
    {({ values, errors, handleBlur, handleChange, handleSubmit }) => (
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">แก้ไขข้อมูลรูปภาพ</p>
          <button
            className="delete"
            aria-label="close"
            onClick={onRequestClose}
          />
        </header>
        <section className="modal-card-body">
          <Field label="ชื่อ">
            <InputText
              name={`title.${language}`}
              placeholder="ชื่อรูปภาพของคุณ"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.title[language]}
              error={errors.title && errors.title[language]}
            />
          </Field>
          <Field label="รายละเอียด">
            <InputTextarea
              name={`description.${language}`}
              placeholder="อธิบายรายละเอียดรูปภาพของคุณ"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.description[language]}
              error={errors.description && errors.description[language]}
            />
          </Field>
        </section>
        <footer
          className="modal-card-foot"
          style={{ justifyContent: 'flex-end' }}
        >
          <button className="button" onClick={onRequestClose}>
            <Trans>actions.cancel.label</Trans>
          </button>
          <button
            className="button is-success"
            onClick={handleSubmit}
            type="submit"
          >
            <Trans>actions.save.label</Trans>
          </button>
        </footer>
      </div>
    )}
  </Formik>
)

export default PortalGalleryImageForm



// WEBPACK FOOTER //
// ./src/components/templates/portal-gallery-image/PortalGalleryImageForm.js